module.exports = __webpack_public_path__ + "static/media/riset.04a34a92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/riset.jpg
// module id = 249
// module chunks = 0